import { Link } from "react-router-dom";
import type { Video } from "@/mocks/videos";
import VideoCard from "@/components/base/VideoCard";
import SectionHeading from "./SectionHeading";

interface FeaturedGridProps {
  videos: Video[];
}

export default function FeaturedGrid({ videos }: FeaturedGridProps) {
  return (
    <section className="w-full px-4 md:px-8">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading
          title="精选推荐"
          desc="编辑精选与高分口碑，值得一看的好内容都在这里"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {videos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
        <div className="mt-6 text-center">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-700 font-medium whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-compass-3-line text-lg"></i>
            发现更多精彩内容
          </Link>
        </div>
      </div>
    </section>
  );
}